import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgGridModule } from 'ag-grid-angular';
import { DataTablesModule } from 'angular-datatables';
import { HighchartsChartModule } from 'highcharts-angular';
import { BaseChartDirective } from 'ng2-charts';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SharedModule } from '../../../../../shared/shared.module';
import { EnitComplainceRoutingModule } from '../../../eComplaince-routing.module';
import { CtclModule } from '../../../EnitTrade/ctcl/ctcl.module';
import { TradeAdminRoutingModule } from '../../../tradeAdmin-routing.module';
import { AppointmentFormComponent } from './appointment-form/appointment-form.component';
import { AppointmentRequestListComponent } from './appointment-request-list/appointment-request-list.component';
import { AuthPersonAppointedListComponent } from './auth-person-appointed-list/auth-person-appointed-list.component';
import { CancellationFormComponent } from './cancellation-form/cancellation-form.component';
import { MisReportMemberComponent } from './mis-report-member/mis-report-member.component';




@NgModule({
  declarations: [
    
    AppointmentFormComponent,
    AppointmentRequestListComponent,
    AuthPersonAppointedListComponent,
    CancellationFormComponent,
    MisReportMemberComponent
    

  ],
  imports: [
    
    CommonModule,
    TradeAdminRoutingModule,
    FormsModule,
    DataTablesModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    BsDatepickerModule,
    SharedModule,
    CtclModule,
    EnitComplainceRoutingModule,
    AgGridModule,
    BaseChartDirective,
    HighchartsChartModule
  ]
})
export class AuthorisePersonMemberModule { }
